import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  setSecondaryTargetDevice,
  fetchAndSelectSecondary,
  replaceDevice,
  retireDevice,
  enableFAT,
  enableOAT,
  sendShelfIdentificationCommand,
  sendDiscoveryCommand,
} from '../actions/device';
import {
  startReplacement,
  startRetire,
  setRetireReason,
  returnToMenu,
  startReprovisionDevice,
  startEnableFAT,
  startEnableOAT,
  startProvision,
  startIdentification,
  startDiscovery,
} from '../actions/management';

import ManagementPage from '../components/pages/ManagementPage';
import ReplacementPage from '../components/pages/ReplacementPage';
import RetirePage from '../components/pages/RetirePage';
import WizardContainer from './WizardContainer';
import FATPage from '../components/pages/FATPage';
import OATPage from '../components/pages/OATPage';
import IdentificationPage from '../components/pages/IdentificationPage';
import DiscoveryPage from '../components/pages/DiscoveryPage';

class ManagementContainer extends Component {
  componentDidMount() {
    this.props.setSecondaryTargetDevice(null);
  }

  render() {
    const {
      state,
      target,
      organization,
      replacement,
      replaceDevice,
      retireDevice,
      startReplacement,
      startRetire,
      fetchAndSelectSecondary,
      setSecondaryTargetDevice,
      returnToMenu,
      isRoot,
      startReprovisionDevice,
      setRetireReason,
      startEnableFAT,
      enableFAT,
      startEnableOAT,
      enableOAT,
      startProvision,
      startIdentification,
      sendShelfIdentificationCommand,
      retiredReason,
      startDiscovery,
      sendDiscoveryCommand,
    } = this.props;

    switch (state) {
      case 'REPLACEMENT':
        return (
          <ReplacementPage
            target={target}
            replacement={replacement}
            fetchReplacement={fetchAndSelectSecondary}
            cancel={() => {
              setSecondaryTargetDevice(null);
              returnToMenu();
            }}
            replace={async () => {
              await replaceDevice(target.id, replacement.id);
            }}
          />
        );
      case 'RETIRE':
        return (
          <RetirePage
            target={target}
            cancel={returnToMenu}
            retiredReason={retiredReason}
            retire={async () => {
              await retireDevice(target.id, retiredReason);
            }}
            onChange={event => {
              const newValue = event.target.value;
              setRetireReason(newValue);
            }}
          />
        );
      case 'REPROVISION':
        return <WizardContainer isReprovision={true} />;
      case 'ENABLE_FAT':
        return (
          <FATPage
            target={target}
            organization={organization}
            cancel={returnToMenu}
            enableFAT={async () => {
              await enableFAT(target.deviceCode, organization);
            }}
          />
        );
      case 'ENABLE_OAT':
        return (
          <OATPage
            target={target}
            organization={organization}
            cancel={returnToMenu}
            enableOAT={async () => {
              await enableOAT(target.deviceCode, organization);
              window.location.href = '/' + target.deviceCode;
            }}
          />
        );
      case 'PROVISION':
        return <WizardContainer />;

      case 'IDENTIFICATION':
        return (
          <IdentificationPage
            target={target}
            organization={organization}
            cancel={returnToMenu}
            startShelfIdentification={async () => {
              await sendShelfIdentificationCommand(
                target.deviceCode,
                'startIdentifyShelves'
              );
            }}
            stopShelfIdentification={async () => {
              await sendShelfIdentificationCommand(
                target.deviceCode,
                'stopIdentifyShelves'
              );
              window.location.href = '/' + target.deviceCode;
            }}
          />
        );

      case 'DISCOVERY':
        return (
          <DiscoveryPage
            target={target}
            organization={organization}
            cancel={returnToMenu}
            startDiscoveryMode={async () => {
              await sendDiscoveryCommand(
                target.deviceCode,
                'startScaleSlotDiscoveryMode'
              );
            }}
            stopDiscoveryMode={async () => {
              await sendDiscoveryCommand(
                target.deviceCode,
                'endScaleSlotDiscoveryMode'
              );
              window.location.href = '/' + target.deviceCode;
            }}
          />
        );

      default:
        return (
          <ManagementPage
            isRoot={isRoot}
            target={target}
            startReplacement={startReplacement}
            startRetire={startRetire}
            startReprovisionDevice={startReprovisionDevice}
            startEnableFAT={startEnableFAT}
            startEnableOAT={startEnableOAT}
            startProvision={startProvision}
            startIdentification={startIdentification}
            startDiscovery={startDiscovery}
          />
        );
    }
  }
}

const mapStateToProps = ({ device, management }) => ({
  target: device.target ? device.devices[device.target] : null,
  organization: device.devices[device.target].deviceOrganization,
  replacement: device.secondaryTarget
    ? device.devices[device.secondaryTarget]
    : null,
  state: management.state,
  retiredReason: management.retiredReason,
});

const mapDispatchToProps = {
  setSecondaryTargetDevice,
  startReplacement,
  startRetire,
  replaceDevice,
  retireDevice,
  fetchAndSelectSecondary,
  returnToMenu,
  startReprovisionDevice,
  startEnableFAT,
  enableFAT,
  startEnableOAT,
  enableOAT,
  startProvision,
  startIdentification,
  sendShelfIdentificationCommand,
  setRetireReason,
  startDiscovery,
  sendDiscoveryCommand,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagementContainer);
